import { contrastRatio } from '@yola/yola-palette-generator';
import reduceColorPointByStep from '../utils/reduce-color-point-by-step';
import reduceColorPointByRatio from '../utils/reduce-color-point-by-ratio';
import increaseOpacity from '../utils/increase-opacity';

const inputDefaultDark = (params, { condition }) => {
  const { targetColor, backgroundColor, backgroundColorPalette, whiteColor } = params;
  const fallback = {
    rule: 'input.borderColor.default.dark',
    params,
  };
  if (condition(contrastRatio(backgroundColor, targetColor))) {
    const reducedBackgroundColor = reduceColorPointByStep({
      targetColor: backgroundColor,
      targetColorPalette: backgroundColorPalette,
      step: 1,
      fallback,
    });

    return reduceColorPointByRatio({
      targetColor: reducedBackgroundColor,
      targetColorPalette: backgroundColorPalette,
      backgroundColor,
      condition,
      fallback,
    });
  }
  return increaseOpacity({
    targetColor: whiteColor,
    backgroundColor,
    opacity: 0.01,
    condition,
    fallback,
  });
};

export default inputDefaultDark;
